import React from "react"
import PropTypes from "prop-types"
import Icon from '../app_components/Icon'
import ProfileLanguageFlag from '../app_components/ProfileLanguageFlag'
import { semantic } from '@lexody/design-tokens'

function ConnectCircleHeader({
  connectCount,
  worldImageUrl,
  searchQuery,
  onSearchChange,
  languageTabs,
  selectedLanguageKey,
  onLanguageSelect,
}) {
  const friendLabel = connectCount === 1 ? 'friend' : 'friends'

  return (
    <header className="connectsCircleHeader">
      <div className="connectsCircleHeader__top">
        <div className="connectsCircleHeader__intro">
          <div className="connectsCircleHeader__titleRow">
            <span className="connectsCircleHeader__icon" aria-hidden="true">
              <Icon
                name="users-alt"
                size={22}
                color={semantic.primary.surface.darker}
                solid={false}
              />
            </span>
            <div className="connectsCircleHeader__titles">
              <h2 className="connectsCircleHeader__title">My Connects</h2>
              <p className="connectsCircleHeader__subtitle">
                {connectCount} {friendLabel} around the world 🌍
              </p>
            </div>
          </div>
        </div>

        {worldImageUrl && (
          <img className="connectsCircleHeader__world" src={worldImageUrl} alt="" />
        )}

        <label className="connectsCircleHeader__search">
          <Icon
            name="search"
            size={18}
            color={semantic.greyscale.text.subtitle}
            solid={false}
          />
          <input
            type="search"
            className="connectsCircleHeader__searchInput"
            placeholder="Search friends..."
            value={searchQuery}
            onChange={(event) => onSearchChange(event.target.value)}
            aria-label="Search friends"
          />
        </label>
      </div>

      {languageTabs.length > 0 && (
        <div className="connectsCircleHeader__languages">
          <button
            type="button"
            className={`connectsCircleHeader__langChip${selectedLanguageKey === 'all' ? ' connectsCircleHeader__langChip--active' : ''}`}
            onClick={() => onLanguageSelect('all')}
          >
            <span>All</span>
            <span className="connectsCircleHeader__langCount">{connectCount}</span>
          </button>
          {languageTabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              className={`connectsCircleHeader__langChip${selectedLanguageKey === tab.key ? ' connectsCircleHeader__langChip--active' : ''}`}
              onClick={() => onLanguageSelect(tab.key)}
            >
              {tab.flagHtml && (
                <ProfileLanguageFlag flagHtml={tab.flagHtml} size={18} />
              )}
              <span>{tab.label}</span>
              <span className="connectsCircleHeader__langCount">{tab.count}</span>
            </button>
          ))}
        </div>
      )}
    </header>
  )
}

ConnectCircleHeader.propTypes = {
  connectCount: PropTypes.number.isRequired,
  worldImageUrl: PropTypes.string,
  searchQuery: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  languageTabs: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    flagHtml: PropTypes.string,
    count: PropTypes.number.isRequired,
  })).isRequired,
  selectedLanguageKey: PropTypes.string.isRequired,
  onLanguageSelect: PropTypes.func.isRequired,
}

export default ConnectCircleHeader
